import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <header className="landing-page__header">
        <div className="landing-page__logo-container">
          <Link to="/">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="AIvatar Logo" className="landing-page__logo" />
          </Link>
        </div>
      </header>
      
      <main className="legal-page__content container">
        <h1>TERMS OF SERVICE</h1>
        
        <section className="legal-page__section">
          <h2>1. GENERAL INFORMATION</h2>
          <p><strong>Business Name</strong>: BOCO<br />
          <strong>RCS (Trade and Companies Register) Number</strong>: 895311082<br />
          <strong>Status</strong>: Sole Proprietorship<br />
          <strong>SIRET Number</strong>: 89531108200021<br />
          <strong>Address</strong>: Les Catalas, 09700 Saverdun France<br />
          <strong>Phone Number</strong>: 0756835116<br />
          <strong>E-mail</strong>: contact@muware.xyz<br />
          <strong>Publication Manager's E-mail</strong>: contact@muware.xyz</p>
          
          <p>These Terms of Service govern your use of our AI avatar creation service (hereinafter referred to as "the Service"), accessible via our websites and applications. By using our Service, you agree to comply with and be bound by these Terms. If you do not agree with any part of these Terms, please do not use our Service.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>2. SERVICE DESCRIPTION</h2>
          <p>The Service provides AI-powered avatar generation based on reference photos uploaded by users. Our proprietary algorithms analyze your photos and create stylized avatars. While our technology is designed to create resembling avatars, we cannot guarantee 100% likeness in all cases, as results may vary depending on various factors including but not limited to photo quality, lighting, angles, and inherent limitations of AI technology.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>3. USER ACCOUNTS AND REGISTRATION</h2>
          <p>3.1. To access certain features of the Service, you may be required to register for an account.</p>
          <p>3.2. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</p>
          <p>3.3. You must provide accurate, current, and complete information during the registration process and update such information as necessary.</p>
          <p>3.4. You agree not to create an account if you are under 18 years of age without parental consent.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>4. USER CONTENT AND CONDUCT</h2>
          <p>4.1. By uploading photos to our Service, you grant us a limited, non-exclusive license to use, process, store, and transfer your images solely for the purpose of providing the Service to you.</p>
          <p>4.2. You must not upload any content that:</p>
          <ul>
            <li>You do not own or have proper authorization to use</li>
            <li>Contains nudity, pornography, or sexually explicit material</li>
            <li>Depicts violence or graphic content</li>
            <li>Infringes on any third party's intellectual property rights</li>
            <li>Contains illegal content or promotes illegal activities</li>
            <li>Features minors without proper parental consent</li>
          </ul>
          <p>4.3. We reserve the right to refuse service, terminate accounts, or remove content at our sole discretion if we believe your use of the Service violates these Terms.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>5. DATA PROCESSING AND STORAGE</h2>
          <p>5.1. Your uploaded photos will be temporarily stored on our servers solely for the purpose of generating avatars.</p>
          <p>5.2. Once the avatar generation process is complete, your original photos will be automatically deleted from our servers.</p>
          <p>5.3. For more information about how we handle your personal data, please refer to our <Link to="/privacy-policy">Privacy Policy</Link>.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>6. PAYMENT TERMS</h2>
          <p>6.1. The prices for our Service are clearly displayed before purchase and are inclusive of all applicable taxes.</p>
          <p>6.2. We use Stripe as our payment processor, and all payment information is handled according to their security standards and policies.</p>
          <p>6.3. By making a purchase, you represent and warrant that you are authorized to use the payment method provided.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>7. REFUND POLICY</h2>
          <p>7.1. Due to the digital nature of our Service and the immediate processing of your content, all sales are final and non-refundable once the avatar generation process has begun.</p>
          <p>7.2. Refunds may be considered at our sole discretion only in cases of:</p>
          <ul>
            <li>Technical issues that prevent delivery of the avatars</li>
            <li>Service unavailability that prevents completion of the avatar generation process</li>
          </ul>
          <p>7.3. Refunds will not be issued based on dissatisfaction with the likeness or artistic quality of the generated avatars, as results may vary and perfect resemblance cannot be guaranteed.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>8. INTELLECTUAL PROPERTY</h2>
          <p>8.1. The Service, including all content, features, and functionality, is owned by BOCO and is protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
          <p>8.2. Upon completion of the avatar generation and payment, you will own the rights to use the generated avatars for personal use.</p>
          <p>8.3. You may not use the generated avatars for commercial purposes without obtaining explicit written permission from us.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>9. DISCLAIMER OF WARRANTIES</h2>
          <p>9.1. THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.</p>
          <p>9.2. We do not guarantee that the Service will meet your specific requirements or expectations regarding likeness or quality of the generated avatars.</p>
          <p>9.3. We do not warrant that the Service will be uninterrupted, timely, secure, or error-free.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>10. LIMITATION OF LIABILITY</h2>
          <p>10.1. TO THE MAXIMUM EXTENT PERMITTED BY LAW, BOCO SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.</p>
          <p>10.2. Our total liability for any claims arising from or relating to these Terms or your use of the Service shall not exceed the amount you paid for the Service during the three (3) months immediately preceding the event giving rise to such liability.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>11. INDEMNIFICATION</h2>
          <p>You agree to defend, indemnify, and hold harmless BOCO, its employees, contractors, agents, officers, and directors from and against any and all claims, damages, obligations, losses, liabilities, costs, or debt, and expenses arising from your use of the Service or your violation of these Terms.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>12. TERM AND TERMINATION</h2>
          <p>12.1. These Terms shall remain in full force and effect while you use the Service.</p>
          <p>12.2. We reserve the right to terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any reason, including but not limited to a breach of these Terms.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>13. CHANGES TO THE TERMS</h2>
          <p>13.1. We reserve the right to modify or replace these Terms at any time at our sole discretion.</p>
          <p>13.2. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect.</p>
          <p>13.3. By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>14. GOVERNING LAW AND JURISDICTION</h2>
          <p>14.1. These Terms shall be governed by and construed in accordance with the laws of France, without regard to its conflict of law provisions.</p>
          <p>14.2. Any dispute arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of France.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>15. HOSTING INFORMATION</h2>
          <p>The Service is hosted by OVH:<br />
          OVH SAS<br />
          2 rue Kellermann<br />
          59100 Roubaix - France</p>
        </section>
        
        <section className="legal-page__section">
          <h2>16. CONTACT INFORMATION</h2>
          <p>If you have any questions about these Terms, please contact us at:<br />
          contact@muware.xyz</p>
        </section>
        
        <p className="legal-page__last-updated">Last updated: May 1, 2025</p>
      </main>
      
      <footer className="footer">
        <div className="container">
          <p>© 2025 AIvatar. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <a href="mailto:contact@muware.xyz">Contact Us</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService; 